import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { InheritanceDeactivateModalContent } from '@shared/services/content/content-jsons/inheritance-deactivate-modal-content';
import { StopPendingEffectsService } from '@src/app/core/services/stop-pending-effects.service';
import { ButtonComponent } from '@vg-constellation/angular-16/button';
import { ModalDialogComponent } from '@vg-constellation/angular-16/modal-dialog';
import { Subscription } from 'rxjs';

import { DeactivateModalService } from './deactivate-modal.service';

@Component({
  selector: 'app-deactivate-modal',
  templateUrl: './deactivate-modal.component.html',
  standalone: true,
  imports: [ModalDialogComponent, ButtonComponent, RouterModule],
})
export class DeactivateModalComponent implements OnInit, OnDestroy {
  public content = InheritanceDeactivateModalContent;
  subscription: Subscription;

  @ViewChild('inheritanceDeactivateModal') inheritanceDeactivateModal: any;

  constructor(
    private deactivateModalService: DeactivateModalService,
    private router: Router,
    private stopPendingEffectsService: StopPendingEffectsService,
  ) {}

  public ngOnInit(): void {
    this.subscription = this.deactivateModalService.deactivateModalOpen$.subscribe(() => {
      this.openModal();
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public closeModal() {
    this.inheritanceDeactivateModal.closeDialogModal();
  }

  public startOver(): void {
    this.stopPendingEffectsService.triggerStop();
    this.navigateOverview();
    this.closeModal();
  }

  private openModal(): void {
    this.inheritanceDeactivateModal.openModalDialog();
    setTimeout(() => {
      window.history.pushState(null, '', window.location.href);
    });
  }

  private navigateOverview(): void {
    this.router.navigateByUrl('/inheritance/overview');
  }
}
